import React from "react";
import PATHS from "utils/paths";
import ZoneLink from "components/ZoneLink";
import { RiArrowRightLine } from "react-icons/ri";
import { HUB_DEV_SETTINGS } from "constants/docs";

const DEFAULT_CLASSES = {
  container:
    "pa2 shadow-0 hairline-1 ba br2 flex flex-column justify-between color-text--primary bg-white--hover",
  content: "w-100 flex flex-row justify-between items-center",
  title: "f5 fw6 color-primary",
  subheader: "f6 pt1",
  iconWrapper:
    "flex flex-row link__decoration--hover items-center flex color-primary pointer"
};

const APIKeysAccessPrompt = ({ needsTestKeys, isUser, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  let content;
  let linkProps;
  if (isUser) {
    linkProps = {
      title: needsTestKeys ? "Enable test mode" : "Access your API keys",
      subheader: needsTestKeys
        ? "Once enabled, each snippet will contain your test API keys."
        : "Your API keys can be found within your app settings.",
      href: HUB_DEV_SETTINGS,
      action: needsTestKeys ? "Enable" : "Access"
    };
  } else {
    linkProps = {
      title: "Get API keys",
      subheader: "Sign up to get access to your own API keys.",
      href: PATHS.SIGNUP,
      action: "Get"
    };
  }
  content = (
    <ZoneLink
      href={linkProps.href}
      linkProps={{
        className: "link",
        target: "_blank"
      }}
    >
      <div className={classes.container}>
        <div className={classes.content}>
          <div className={classes.title}>{linkProps.title}</div>
          <div className={classes.iconWrapper}>
            <RiArrowRightLine size={22} />
          </div>
        </div>
        {linkProps.subheader && (
          <div className={classes.subheader}>{linkProps.subheader}</div>
        )}
      </div>
    </ZoneLink>
  );

  return content;
};

export default APIKeysAccessPrompt;
